export default __webpack_public_path__ + "static/media/GPA_Banner_Power_Alerts.24958884.jpg";